module.exports = __webpack_public_path__ + "static/media/partner_litterlocker.3bfec31e.jpg";